import PropTypes from "prop-types";

/**
 * PropTypes for DualRange component
 *
 * @property {number} [min] - Minimum range value
 * @property {number} [max] - Maximum range value
 * @property {number} [step] - Step increment
 * @property {Array<number>} [defaultValue] - Default min/max values
 * @property {function} [onChange] - Change handler callback
 * @property {boolean} [disabled] - Disabled state
 * @property {boolean} [showValue] - Show range values below slider
 * @property {string} [unit] - Unit display (e.g., "kW", "€"). Defaults to "kW"
 */
export const dualRangePropTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  defaultValue: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  showValue: PropTypes.bool,
  unit: PropTypes.string,
};
